module.exports = __webpack_public_path__ + "static/home-search-form-back-2-5b0cf7535c1cd41312e872e8fe3b16ac.png";